import Http from '@/services/Http';

const usersPath = 'users';
const verificationCodeUserRequests = new Http(usersPath);

verificationCodeUserRequests.generateCode = (uuid, data) => {
  verificationCodeUserRequests.supressDefault = true;
  return verificationCodeUserRequests.post(
    data,
    `${usersPath}/${uuid}/verification-code`
  );
};

export default verificationCodeUserRequests;
